/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Clear_Text_CancelInputs */

const en_shortcut_keys_clear_text_cancel = /** @type {(inputs: Shortcut_Keys_Clear_Text_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_shortcut_keys_clear_text_cancel = /** @type {(inputs: Shortcut_Keys_Clear_Text_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_shortcut_keys_clear_text_cancel = /** @type {(inputs: Shortcut_Keys_Clear_Text_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_shortcut_keys_clear_text_cancel = /** @type {(inputs: Shortcut_Keys_Clear_Text_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_shortcut_keys_clear_text_cancel = /** @type {(inputs: Shortcut_Keys_Clear_Text_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_shortcut_keys_clear_text_cancel = /** @type {(inputs: Shortcut_Keys_Clear_Text_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_shortcut_keys_clear_text_cancel = /** @type {(inputs: Shortcut_Keys_Clear_Text_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_shortcut_keys_clear_text_cancel = /** @type {(inputs: Shortcut_Keys_Clear_Text_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_shortcut_keys_clear_text_cancel = /** @type {(inputs: Shortcut_Keys_Clear_Text_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_shortcut_keys_clear_text_cancel = /** @type {(inputs: Shortcut_Keys_Clear_Text_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Shortcut_Keys_Clear_Text_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_clear_text_cancel = /** @type {((inputs?: Shortcut_Keys_Clear_Text_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Clear_Text_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_clear_text_cancel(inputs)
	if (locale === "de") return de_shortcut_keys_clear_text_cancel(inputs)
	if (locale === "it") return it_shortcut_keys_clear_text_cancel(inputs)
	if (locale === "ru") return ru_shortcut_keys_clear_text_cancel(inputs)
	if (locale === "es") return es_shortcut_keys_clear_text_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_clear_text_cancel(inputs)
	if (locale === "ja") return ja_shortcut_keys_clear_text_cancel(inputs)
	if (locale === "hi") return hi_shortcut_keys_clear_text_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_clear_text_cancel(inputs)
	return en_shortcut_keys_clear_text_cancel(inputs)
});